import { colors, fonts } from 'components/styles/variables';
import InputSliderBlock, {
  InputSliderBlockValue,
} from 'components/Shared/SearchFilter/InputSliderBlock';
import useEvents from 'lib/hooks/useEvents';
import viewEvent from 'lib/Tracking/Onboarding/ViewEvent';
import { useFilterContext } from 'contexts/OnboardingFilterContext';
import { useEffect } from 'react';
import { SourcePages } from 'lib/EventSchema';
import { OnboardingComponentProps } from '../Modal';
import Button from '../Buttons/Button';
import AutolistLogo from '../Logo';

function Budget({ t, onNextStep }: OnboardingComponentProps): JSX.Element {
  const logger = useEvents();
  const { filterData, updateFilterData } = useFilterContext();

  function onChange(val: InputSliderBlockValue): void {
    updateFilterData({
      Price: {
        ...filterData.Price,
        ...val,
      },
    });
  }

  useEffect(() => {
    logger.log(viewEvent({ sourcePage: SourcePages.OnboardingPriceRange }));
  }, [logger]);

  return (
    <>
      <div className="budget-step-container">
        <div className="budget-content">
          <AutolistLogo />
          <div className="header">{t('onboarding.budgetScreen.header')}</div>
          <div className="subtitle">{t('onboarding.budgetScreen.subText')}</div>
          <div className="slider-container">
            <InputSliderBlock
              onChange={onChange}
              minAllowed={0}
              maxAllowed={100000}
              initialMin={0}
              initialMax={100000}
              minPlaceholder={'$0'}
              maxPlaceholder={'$100,000+'}
              pushable={false}
              step={500}
              hasThousandSeparator={true}
              getMinPrefix={(): string => '$'}
              getMaxPrefix={(): string => '$'}
              getMaxSuffix={({ numericValue }): string | undefined =>
                numericValue && numericValue >= 100000 ? '+' : undefined
              }
            />
          </div>
        </div>
        <div>
          <Button
            onClick={(): void =>
              onNextStep({
                min_price: filterData.Price?.min,
                max_price: filterData.Price?.max,
              })
            }
          >
            {t('onboarding.next')}
          </Button>
        </div>
      </div>

      <style jsx>{`
        .budget-step-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 564px;
          justify-content: space-between;
          width: 295px;
        }
        .budget-content {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .input-slider-block-container {
          width: 295px;
        }
        .slider-container {
          width: 295px;
        }
        .header {
          text-align: center;
          font-family: ${fonts.default};
          font-weight: 700;
          font-size: 22px;
          line-height: 32px;
          letter-spacing: 0.2px;
          margin-bottom: 20px;
        }
        .subtitle {
          text-align: center;
          font-family: ${fonts.default};
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.2px;
          color: ${colors.G3};
          margin-bottom: 64px;
        }
      `}</style>
    </>
  );
}

export default Budget;
